//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {querydevicelocationhistory} from '../../api/device'

export default {
  name: 'mapCat',
  data () {
    return {
      deviceData: '',
      selectTitle: 0,
      mapObj: {
        lngLat: [114.0723, 22.4045],
        lngLatArr: [],
        isMarker: true
      },
      showYearTime: false,
      yTime: '',
      yTimeInfo: new Date(),
      manDate: new Date(2022, 12, 12),
      isLine: false
    }
  },
  created () {
    this.golobleObject.getStartMap = this.getShowMarker
    this.deviceData = this.$store.getters.get_child_obj
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let day = new Date().format('yyyy-MM-dd')
    this.yTime = day
    this.getHistoryLocation()
    if (this.deviceData.lng !== 0 && this.deviceData.lat !== 0) {
      this.mapObj.lngLat = [this.deviceData.lng, this.deviceData.lat]
      this.mapObj.isMarker = true
    } else {}
    document.getElementsByTagName('title')[0].innerText = '定位详情'
  },
  mounted () {},
  beforeDestroy () {
    document.getElementsByTagName('title')[0].innerText = '智慧安防'
  },
  methods: {
    onConfirm (time) {
      console.log(time)
      this.yTime = time.format('yyyy-MM-dd')
      this.isLine = true
      this.getHistoryLocation()
      this.showYearTime = false
    },
    getHistoryLocation () {
      let data = {
        imei: this.deviceData.deviceid,
        did: this.deviceData.id,
        from: this.yTime + ' 00:00:00',
        to: this.yTime + ' 23:59:59'
      }
      querydevicelocationhistory(data).then(res => {
        console.log(123, res)
        if (res.data && res.data.length > 0) {
          this.mapObj.lngLatArr = res.data
        } else {
          this.mapObj.lngLatArr = []
        }
        if (this.isLine) {
          window.frames['mainIframe'].window.startData(this.mapObj)
        }
        this.isLine = false
      }).catch(() => {})
    },
    openTitleSelect (index) {
      this.selectTitle = index
      if (index === 1) {
        this.mapObj.isMarker = false
      } else {
        this.mapObj.isMarker = true
      }
      window.frames['mainIframe'].window.startData(this.mapObj)
    },
    getShowMarker () {
      window.frames['mainIframe'].window.startData(this.mapObj)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/mapCat.vue